<template>
  <div>
    <el-card class="mb15" shadow="hover">
      <el-row>
        <el-input
          :placeholder="$t('search')"
          clearable
          v-model="filter.search"
          @keyup.enter.native="get_list"
        ></el-input>
      </el-row>
      <el-row class="mt20" type="flex" :gutter="20" align="middle">
        <span class="text">{{ $t('activityList.type') }}:</span>
        <el-radio-group size="medium" v-model="filter.type">
          <el-radio label>{{ $t('all') }}</el-radio>
          <el-radio :label="2">{{ type(2) }}</el-radio>
          <el-radio :label="1">{{ type(1) }}</el-radio>
        </el-radio-group>
      </el-row>
      <el-row class="mt20" type="flex" :gutter="20" align="middle">
        <span class="text">{{ $t('activityList.status') }}:</span>
        <el-radio-group size="medium" v-model="filter.status">
          <el-radio label>{{ $t('all') }}</el-radio>
          <el-radio :label="0">{{ status(0) }}</el-radio>
          <el-radio :label="1">{{ status(1) }}</el-radio>
          <el-radio :label="2">{{ status(2) }}</el-radio>
          <el-radio :label="3">{{ status(3) }}</el-radio>
        </el-radio-group>
      </el-row>
      <el-row class="mt20" type="flex" :gutter="20" align="middle">
        <span class="text">{{ $t('activityList.active') }}:</span>
        <el-radio-group size="medium" v-model="filter.active">
          <el-radio label>{{ $t('all') }}</el-radio>
          <el-radio :label="0">{{ active(0) }}</el-radio>
          <el-radio :label="1">{{ active(1) }}</el-radio>
        </el-radio-group>
      </el-row>
      <el-row class="mt20" type="flex" align="middle">
        <el-button @click="get_list" type="primary" class="search">{{
          $t('search_zh')
        }}</el-button>
        <el-button @click="reset" type="info">{{
          $t('btnTip.reset')
        }}</el-button>
      </el-row>
    </el-card>
    <el-card shadow="hover">
      <div class="flexBC mb20">
        <el-button type="primary" @click="handleClick('add')">{{
          $t('btnTip.add')
        }}</el-button>
        <el-button type="primary" @click="outExe">{{ $t('outExe') }}</el-button>
      </div>
      <my-table
        :columns="columns"
        :data="list_data.list"
        :showIndex="false"
        :showSelection="false"
        :cellStyle="{ padding: '6px 0' }"
        :headerCellStyle="{
          background: 'rgba(51, 55, 68, 1)',
          color: '#fff',
        }"
        @emitSelection="allSelect"
        @sortChange="sort_change"
      >
        <template v-slot:type="slotProps">
          <div>
            {{ type(slotProps.callback.row.type) }}
          </div>
        </template>
        <template v-slot:title="slotProps">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('activityList.toActivityUserList')"
            placement="top"
          >
            <div>
              {{ slotProps.callback.row.title }}
            </div>
          </el-tooltip>
        </template>
        <template v-slot:apply_num="slotProps">
          <div
            class="under_line"
            @click="handleClick('activity_userList', slotProps.callback.row)"
          >
            {{ slotProps.callback.row.apply_num }}/{{
              slotProps.callback.row.total_num
            }}
          </div>
        </template>
        <template v-slot:cover="slotProps">
          <div>
            <img width="100%" :src="slotProps.callback.row.cover" alt />
          </div>
        </template>
        <template v-slot:status="slotProps">
          <el-tag :type="statusTag(slotProps.callback.row.status)">
            {{ status(slotProps.callback.row.status) }}
          </el-tag>
        </template>
        <template v-slot:active="slotProps">
          <el-tag :type="activeTag(slotProps.callback.row.active)">
            {{ active(slotProps.callback.row.active) }}
          </el-tag>
        </template>
        <template v-slot:operation="slotProps">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').check"
            placement="top"
          >
            <el-button
              @click="handleClick('check', slotProps.callback.row)"
              icon="el-icon-view"
              type="success"
              size="mini"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').edit"
            placement="top"
          >
            <el-button
              @click="handleClick('edit', slotProps.callback.row)"
              icon="el-icon-edit-outline"
              type="primary"
              size="mini"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').delete"
            placement="top"
          >
            <el-button
              size="mini"
              type="danger"
              @click="del(slotProps.callback.row.id)"
              >{{ $t('btnTip').delete }}</el-button
            >
          </el-tooltip>
        </template>
      </my-table>
      <page
        :total="list_data.total"
        :page_size.sync="pageSize"
        :page.sync="page"
      />
    </el-card>
  </div>
</template>
<script>
import { mixin_list } from '@/mixins';
import page from '@/components/page';
import myTable from '@/components/table';
import { activityList, deleteActivity } from '@/api/api';
export default {
  name: 'activityList',
  mixins: [mixin_list(activityList)],
  components: {
    myTable,
    page,
  },
  data() {
    return {
      filter: {
        search: '',
        type: '',
        status: '',
        active: '',
      },
      columns: [
        {
          label: 'ID',
          sortable: true,
          prop: 'id',
          width: 80,
        },
        {
          label: this.$t('activityList.create_time'),
          sortable: true,
          prop: 'create_time',
        },
        {
          label: this.$t('activityList.update_time'),
          sortable: true,
          prop: 'update_time',
        },
        {
          label: this.$t('activityList.title'),
          sortable: true,
          prop: 'title',
          slot: 'title',
        },
        {
          label: this.$t('activityList.cover'),
          sortable: true,
          slot: 'cover',
          prop: 'cover',
        },
        {
          label: this.$t('activityList.type'),
          sortable: true,
          prop: 'type',
          slot: 'type',
        },
        {
          label: this.$t('activityList.price'),
          sortable: true,
          prop: 'price',
        },
        {
          label: this.$t('activityList.num'),
          sortable: true,
          prop: 'apply_num',
          slot: 'apply_num',
        },
        {
          label: this.$t('activityList.order'),
          sortable: true,
          prop: 'order',
        },
        {
          label: this.$t('activityList.status'),
          sortable: true,
          slot: 'status',
          prop: 'status',
        },
        {
          label: this.$t('activityList.active'),
          sortable: true,
          slot: 'active',
          prop: 'active',
        },
        {
          label: this.$t('operation'),
          prop: '',
          width: 250,
          slot: 'operation',
        },
      ],
    };
  },
  methods: {
    activeTag(active) {
      switch (active) {
        case 0:
          return 'info';
        case 1:
          return 'success';
      }
    },
    active(active) {
      switch (active) {
        case 0:
          return this.$t('activityList.active0');
        case 1:
          return this.$t('activityList.active1');
      }
    },
    statusTag(status) {
      switch (status) {
        case 0:
          return 'primary';
        case 1:
          return 'success';
        case 2:
          return 'danger';
        case 3:
          return 'info';
      }
    },
    status(status) {
      switch (status) {
        case 0:
          return this.$t('activityList.status0');
        case 1:
          return this.$t('activityList.status1');
        case 2:
          return this.$t('activityList.status2');
        case 3:
          return this.$t('activityList.status3');
      }
    },
    type(type) {
      switch (type) {
        case 1:
          return this.$t('activityList.type2');
        case 2:
          return this.$t('activityList.type1');
      }
    },
    async handleClick(type, data) {
      switch (type) {
        case 'add':
          this.$router.push('/activityManagement/activityList/edit');
          break;
        case 'edit':
          this.$router.push(
            `/activityManagement/activityList/edit?id=${data.id}`
          );
          break;
        case 'check':
          this.$router.push(
            `/activityManagement/activityList/detail?id=${data.id}`
          );
          break;
        case 'activity_userList':
          this.$router.push(
            `/activityManagement/activity_userList?id=${data.id}`
          );
          break;
      }
    },
    async del(id) {
      this.$confirm(
        this.$t('activityList').sureDeleteActivity,
        this.$t('tips'),
        {
          confirmButtonText: this.$t('btnTips').submit,
          cancelButtonText: this.$t('btnTips').cancel,
          type: 'warning',
        }
      )
        .then(async () => {
          let res = await deleteActivity(id);
          this.get_list();
        })
        .catch({});
    },
  },
};
</script>
<style lang="scss" scoped>
.text {
  width: 100px;
  font-size: 16px;
}
/deep/ label {
  margin-bottom: 0 !important;
}
</style>
